import XHeader from 'vux/src/components/x-header/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Toast from 'vux/src/components/toast/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

export default {
name: 'shoppingCart',
directives: {
TransferDom
},
components: {
XHeader,
CheckIcon,
Group,
XButton,
Confirm,
Toast,
Loading,
Tab,
TabItem
},
data () {
return {
isCheck: true,
num: 0,
cartNum: 0,
show: false,
deling: false,
confirmType: '',
cartList: [],
showDel: false,
singleDelItem: '',
singleDelIndex: '',
noGoods: false,
orderStatus: '',
goWhere: '',
}
},
methods: {
getCookie(name) {
var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
if (arr = document.cookie.match(reg))
return unescape(arr[2]);
else
return null;
},
editGoods () {  //编辑商品
this.showDel = !this.showDel
},
batchDel () {   //批量删除
if(this.settlementNum == 0){
this.$vux.toast.show({
type: 'warn',
text: '请勾选商品'
})
}else{
this.confirmType = 'batchDel'
this.show = true
}
},
goShop () {
if(this.orderStatus == 'productCenter'){
this.$router.push({
path: '/shop'
})
}else if(this.orderStatus == 'small3dSoftware'){
this.$router.push({
path: '/customization'
})
}else if(this.orderStatus == 'print'){
this.$router.push({
path: '/print'
})
}
},
productCenter (code) {
this.orderStatus = 'productCenter'
this.goWhere = '去商城'
this.getCartList(code)
},
small3dSoftware (code) {
this.orderStatus = 'small3dSoftware'
this.goWhere = '3D小软件'
this.getCartList(code)
},
print (code) {
this.orderStatus = 'print'
this.goWhere = '去打印'
this.getCartList(code)
},
regNum (e,item,index) {
let val = Number(e.target.value)
let reg = /^[1-9]\d*$/
if(!reg.test(val)){
val = 1
}

item.qty = val
item.singlePrice = item.promotionPrice * item.qty
this.updateQty(item.id,item.qty)
},
add (item,index) {  //数量+1
item.qty += 1
item.singlePrice = item.promotionPrice * item.qty
this.updateQty(item.id,item.qty)
},
subtract (item,index) { //数量-1
if(item.qty > 1){
item.qty -= 1
}
item.singlePrice = item.promotionPrice * item.qty
this.updateQty(item.id,item.qty)
},
toggleCheck (item) {
if(this.orderStatus == 'productCenter'){
if(item.soldStatus != '上架'){

item.check = false
this.$vux.toast.show({
type: 'warn',
text: '该商品已下架'
})
}
}
},
getCartList (skuCode) {  //获取购物车
this.$request.post('/cart/list',{
skuCode,
}).then(data => {
if(data.code == 0){
data.obj.map((item, index) => {
item.goodsIndex = index
if(this.orderStatus == 'productCenter'){
if(item.soldStatus != '上架'){

item.check = false
}else{
item.check = true
}
}else{
item.check = true
}
item.singlePrice = item.promotionPrice * item.qty
})
this.cartList = data.obj
this.cartNum = this.cartList.length
if(data.obj.length != 0){
this.noGoods = false
}else{
this.noGoods = true
}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})

},
updateQty (id, num) {
this.$request.post('/cart/updateqty',{
cartId: id,
qty: num
}).then(data => {
if(data.code == 0){
console.log('数量变更成功')
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
singleDel (item,index) {
this.confirmType = 'singleDel'
this.show = true
this.singleDelItem = item
this.singleDelIndex = index
},
onConfirm () {  // 确定删除
this.deling = true
if(this.confirmType == 'batchDel'){  //批量删除
let cartIds = []
this.cartList.forEach((value, item) => {
if(value.check){
cartIds.push(value.id)
}
})

this.$request.post('/cart/deleteByIdlist',{
token: this.getCookie('_token'),
cartIds
}).then(data => {
if(data.code == 0){
this.cartList = this.cartList.filter((item,index) => {
return !item.check
})
this.cartNum = this.cartList.length
if(this.cartNum == 0){
this.noGoods = true
}else{
this.noGoods = false
}






this.deling = false
this.$vux.toast.show({
type: 'success',
text: '删除成功'
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}else if(this.confirmType == 'singleDel'){  //单个删除
console.log(this.singleDelItem)
console.log(this.singleDelIndex)
this.$request.post('/cart/deleteById',{
token: this.getCookie('_token'),
id: this.singleDelItem.id
}).then(data => {
if(data.code == 0){
this.cartList.splice(this.singleDelIndex,1)
this.cartNum -= 1
if(this.cartNum == 0){
this.noGoods = true
}else{
this.noGoods = false
}
this.deling = false
this.$vux.toast.show({
type: 'success',
text: '删除成功'
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}
},
buy () {  //结算
if(this.settlementNum == 0){
this.$vux.toast.show({
type: 'warn',
text: '请勾选商品'
})
}else{
let settlementList = this.cartList.filter((item,index) => {
return item.check
})
let addCartArr = []
settlementList.forEach((item,index) => {
let obj = {}
obj.token = this.getCookie('_token')
obj.id = item.id
obj.skuId = item.skuId
obj.qty = item.qty
addCartArr.push(obj)
})

this.$request.post('/cart/settlement',
addCartArr
).then(data => {
if(data.code == 0){
this.$router.push({
path: '/submitOrder',
query: {
cartType: "cart",
type: this.orderStatus
}
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}
},
commodity (item, index) {
console.log(JSON.parse(JSON.stringify(item)))
this.$router.push({
path: '/commodity',
query: {
id: item.spuId
}
})
},
},
created () {
if(this.$route.query.type == 'productCenter'){
this.orderStatus = 'productCenter'
this.goWhere = '去商城'
this.getCartList('08')
}else if(this.$route.query.type == 'print'){
this.orderStatus = 'print'
this.goWhere = '去打印'
this.getCartList('07')
}else{
this.orderStatus = 'small3dSoftware'
this.goWhere = '去3D小软件'
this.getCartList('01')
}
},
computed: {
totalMoney () { //计算全部商品总价
let totalPrice = 0
if(this.orderStatus == 'print'){
this.cartList.forEach((item, index) => {
if(item.check){

totalPrice = ((totalPrice * 1000)+(((Number(item.promotionPrice)*1000 * Number(item.qty)*1000)/1000000)*1000))/1000
}
})
}else{
this.cartList.forEach((item, index) => {
if(item.check){

totalPrice = ((totalPrice*1000)+(((Number(item.salePrice)*1000 * Number(item.qty)*1000)/1000000)*1000))/1000
}
})
}
return totalPrice
},
settlementNum () {  //结算数量
let num = 0
this.cartList.forEach((item, index) => {
if(item.check){
num += 1
}
})
return num
},
isAllCheck: { //全选、反选
get () {
if(this.orderStatus == 'productCenter'){
let newCartList = this.cartList.filter((item, index) => {
return item.soldStatus == '上架'
})
return newCartList.every((item) => {
return item.check
})
}else{
return this.cartList.every((item) => {
return item.check
})
}
},
set (check) {
if(this.orderStatus == 'productCenter'){
let newCartList = this.cartList.filter((item, index) => {
return item.soldStatus == '上架'
})
newCartList.forEach(element => {
element.check = check;
});
}else{
this.cartList.forEach(element => {
element.check = check;
});
}
}
}
},
}



// WEBPACK FOOTER //
// ./src/views/shoppingCart/script.js